export default "__VITE_ASSET__CMW66s4X__"